/* galaxy-cart-fixes.js - Galaxy Apparel, 2026-09-26
 * Works alongside Hulk Discounts / Hulk Product Options (does not modify Hulk):
 * 1. Readiness: Hulk prices the cart via a server call (get_cart_details) after page load and after every cart change.
 *    Until that call completes, the page shows Shopify's plain numbers and a checkout click skips Hulk's draft order
 *    (setup fee + bulk discount lost). Readiness is read from resource timing (no request wrapping).
 * 2. "Calculating\u2026" instead of cart numbers while not ready.
 * 3. Checkout guard: hold checkout clicks until ready (max 10 s).
 * 4. Order summary: Subtotal / Bulk savings / Total instead of the same crossed-out pair twice.
 * 5. Setup-fee lines: real per-item price + "incl. $X one-off setup" note.
 * 6. Minimum per logo line (Logo Embroidery 5, Logo/Design Printing 10): Avada counts per variant, so a second
 *    logo/position could be added at qty 1. Checked on Add to Cart, flagged on cart lines, blocks checkout.
 * 7. Theme "Edit" pencil hidden on logo lines (it re-adds the line without its options = setup fee lost).
 * If Hulk never responds, everything falls back to the original display after 10 s.
 */
(function () {
  if (window.__galaxyCartFixes) return;
  window.__galaxyCartFixes = true;
  var MAX_WAIT = 10000, SETTLE = 700;
  var lastMutationEnd = 0, lastCalcEnd = -1, itemCount = null, hasFee = false, ready = false, gaveUp = false, notReadySince = Date.now();
  var FEE_RE = /\[\s*\$\s*([\d,]+(?:\.\d+)?)\s*\]/g;
  var CHECKOUT_SEL = "button[name='checkout'], input[name='checkout'], a[href$='/checkout'], .hulkapps_checkout";

  var css = document.createElement('style');
  css.textContent =
    'html.galaxy-calc [data-hulkapps-cart-total],html.galaxy-calc .hulkapps-cart-total,html.galaxy-calc .galaxy-amt,' +
    'html.galaxy-calc [data-hulkapps-line-price],html.galaxy-calc [data-hulkapps-ci-price],html.galaxy-calc .galaxy-unit,' +
    'html.galaxy-calc .galaxy-note,html.galaxy-calc .galaxy-savings-row,html.galaxy-calc .galaxy-qtyline{visibility:hidden}' +
    '.galaxy-calc-label{display:none;font-style:italic;opacity:.75}html.galaxy-calc .galaxy-calc-label{display:inline;visibility:visible}' +
    '.galaxy-hide{display:none!important}.galaxy-note{display:block;font-size:13px;line-height:1.35;opacity:.8;margin-top:2px}' +
    '.galaxy-unit s{opacity:.6;margin-right:4px}' +
    '.galaxy-summary-box>[data-hulkapps-cart-total],.galaxy-summary-box>.hulkapps-cart-total{display:none!important}' +
    '.galaxy-qtyline{display:block;font-size:13px;line-height:1.4;margin:4px 0 6px}' +
    '.previewCartItem .product-option{display:block!important;margin:0 0 2px!important;font-size:12px;line-height:1.35}' +
    '.previewCartItem .product-option dt,.previewCartItem .product-option dd{display:inline!important;width:auto!important;' +
    'max-width:none!important;flex:none!important;margin:0!important;padding:0!important;font-size:12px!important;color:#6b6b6b}' +
    '.previewCartItem .product-option dt{font-weight:600;margin-right:4px!important}' +
    '.galaxy-props .product-option{display:flex!important;align-items:baseline;gap:6px;margin:0 0 3px!important}' +
    '.galaxy-props dt{flex:0 0 auto!important;width:auto!important;min-width:0!important;max-width:none!important;font-weight:600;margin:0!important}' +
    '.galaxy-props dd{flex:1 1 auto!important;width:auto!important;min-width:0!important;max-width:none!important;margin:0!important}' +
    '.previewCartItem .galaxy-props .product-option{display:block!important}';
  document.head.appendChild(css);

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function feeOf(props) {
    var sum = 0, m;
    if (!props) return 0;
    Object.keys(props).forEach(function (k) {
      var v = String(props[k]); FEE_RE.lastIndex = 0;
      while ((m = FEE_RE.exec(v))) sum += parseFloat(m[1].replace(/,/g, ''));
    });
    return sum;
  }
  function props(item) {
    if (!item || !item.properties) return null;
    if (typeof item.properties === 'string') { try { return JSON.parse(item.properties); } catch (e) { return null; } }
    return item.properties;
  }
  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }
  function setHTML(el, h) { if (el.__gh !== h) { el.innerHTML = h; el.__gh = h; } }
  function labelAll() { document.querySelectorAll('[data-hulkapps-cart-total]').forEach(function (el) { ensureCalcLabel(el.parentElement); }); }
  function data() { return window.hulkapps && window.hulkapps.discounts && window.hulkapps.discounts.cart ? window.hulkapps.discounts : null; }

  /* ---------- readiness from resource timing ---------- */
  function onEntry(e) {
    var n = e.name || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(n)) {
      if (e.responseEnd > lastMutationEnd) lastMutationEnd = e.responseEnd;
      setNotReady(); refreshCount();
    } else if (/get_cart_details/.test(n)) {
      if (e.startTime >= lastMutationEnd - 5 && e.responseEnd > lastCalcEnd) {
        lastCalcEnd = e.responseEnd;
        setTimeout(evaluate, SETTLE);
      }
    }
  }
  try { performance.setResourceTimingBufferSize(2000); } catch (e) {}
  try {
    new PerformanceObserver(function (list) { list.getEntries().forEach(onEntry); }).observe({ type: 'resource', buffered: true });
  } catch (e) { gaveUp = true; }

  var cartItems = null, itemsAt = -1;
  function refreshCount() {
    var t = performance.now();
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) {
        itemCount = c.item_count; hasFee = (c.items || []).some(function (i) { return feeOf(i.properties) > 0; });
        if (t > itemsAt) { cartItems = c.items || []; itemsAt = t; }
        evaluate();
      }).catch(function () {});
  }
  function isReady() {
    if (gaveUp) return true;
    if (itemCount === 0) return true;
    // also wait SETTLE ms after Hulk's reply so its own success handler (draft-order flag, DOM) has run
    return itemCount !== null && lastCalcEnd > lastMutationEnd && performance.now() - lastCalcEnd > SETTLE && !!data();
  }
  function setNotReady() {
    if (ready || !document.documentElement.classList.contains('galaxy-calc')) notReadySince = Date.now();
    ready = false;
    if (!gaveUp) document.documentElement.classList.add('galaxy-calc');
  }
  function evaluate() {
    if (isReady()) {
      ready = true;
      document.documentElement.classList.remove('galaxy-calc');
      render();
    } else if (Date.now() - notReadySince > MAX_WAIT) {
      labelAll();
      ready = true; // give up for this cycle: show whatever the page has
      document.documentElement.classList.remove('galaxy-calc');
    }
  }
  setInterval(function () { if (!ready) labelAll(); evaluate(); try { tidyProps(); } catch (e) {} }, 500);
  document.addEventListener('DOMContentLoaded', labelAll);
  setNotReady();
  refreshCount();

  /* ---------- display ---------- */
  function ensureCalcLabel(container) {
    if (!container.querySelector(':scope > .galaxy-calc-label')) {
      var s = document.createElement('span'); s.className = 'galaxy-calc-label'; s.textContent = 'Calculating\u2026';
      container.appendChild(s);
    }
  }
  function amountSpan(container) {
    var s = container.querySelector(':scope > .galaxy-amt');
    if (!s) { s = document.createElement('span'); s.className = 'galaxy-amt'; container.appendChild(s); }
    return s;
  }
  function rowOf(el) {
    var r = el;
    for (var i = 0; i < 5 && r; i++) {
      if (/total/i.test((r.textContent || '').replace(/\$[\d.,]+/g, '')) && /LI|TR|DIV/.test(r.tagName) && r !== el.parentElement) return r;
      r = r.parentElement;
    }
    return el.parentElement.parentElement;
  }
  function renderSummary(d) {
    var orig = parseFloat(d.original_line_price_total), disc = parseFloat(d.discounted_line_price_total);
    if (isNaN(orig) || isNaN(disc)) return;
    var saving = Math.round((orig - disc) * 100) / 100;
    var groups = {};
    document.querySelectorAll('[data-hulkapps-cart-total]').forEach(function (el) {
      var row = rowOf(el), box = row.parentElement;
      var key = box ? (box.__galaxyId || (box.__galaxyId = Math.random().toString(36).slice(2))) : 'x';
      (groups[key] = groups[key] || []).push({ el: el, row: row });
    });
    Object.keys(groups).forEach(function (k) {
      var g = groups[k], sub = null, tot = null;
      g.forEach(function (x) {
        var label = (x.row.textContent || '').replace(/\$[\d.,]+/g, '').toLowerCase();
        if (x.row.classList.contains('galaxy-savings-row')) return;
        if (/subtotal/.test(label)) { if (!sub) sub = x; } else if (/total/.test(label)) tot = x;
      });
      if (!tot && g.length) tot = g[g.length - 1];
      [sub, tot].forEach(function (x) {
        if (!x) return;
        var box = x.el.parentElement;
        box.classList.add('galaxy-summary-box');
        x.el.classList.add('galaxy-hide');
        var dsp = box.querySelector('.hulkapps-cart-total'); if (dsp) dsp.classList.add('galaxy-hide');
        ensureCalcLabel(box);
      });
      if (tot) setText(amountSpan(tot.el.parentElement), money(disc));
      var sv = tot && tot.row.parentElement.querySelector(':scope > .galaxy-savings-row');
      if (saving > 0.004 && sub) {
        sub.row.classList.remove('galaxy-hide');
        setText(amountSpan(sub.el.parentElement), money(orig));
        if (!sv) {
          // copy of the subtotal row (same styling) with every Hulk hook and "subtotal" class stripped, so Hulk never writes into it
          sv = sub.row.cloneNode(true);
          [sv].concat([].slice.call(sv.querySelectorAll('*'))).forEach(function (n) {
            [].slice.call(n.attributes).forEach(function (a) { if (/^data-hulkapps/.test(a.name) || a.name === 'id') n.removeAttribute(a.name); });
            [].slice.call(n.classList).forEach(function (c) { if (/hulk|sub-?total|galaxy-(hide|calc-label)/i.test(c)) n.classList.remove(c); });
          });
          sv.classList.add('galaxy-savings-row');
          sv.style.display = 'flex'; sv.style.justifyContent = 'space-between'; sv.style.alignItems = 'center';
          var amt = sv.querySelector('.galaxy-amt');
          if (amt) {
            [].slice.call(amt.parentNode.childNodes).forEach(function (c) { if (c !== amt) c.parentNode.removeChild(c); });
            amt.className = 'galaxy-savings-amt';
            var vwrap = amt.parentNode; while (vwrap && vwrap.parentNode !== sv) vwrap = vwrap.parentNode;
            if (vwrap) { vwrap.style.marginLeft = 'auto'; vwrap.style.float = 'none'; }
          } else { sv.insertAdjacentHTML('beforeend', '<span class="galaxy-savings-amt"></span>'); }
          var tw = document.createTreeWalker(sv, NodeFilter.SHOW_TEXT), tn;
          while ((tn = tw.nextNode())) if (/subtotal/i.test(tn.nodeValue)) tn.nodeValue = tn.nodeValue.replace(/sub\s*total/i, 'Bulk savings');
          sub.row.parentNode.insertBefore(sv, sub.row.nextSibling);
        }
        setText(sv.querySelector('.galaxy-savings-amt'), '\u2212' + money(saving));
      } else {
        if (sub) sub.row.classList.add('galaxy-hide');
        if (sv) sv.remove();
      }
    });
  }
  function renderLines(d) {
    var byKey = {};
    d.cart.items.forEach(function (it) { byKey[it.key] = it; });
    document.querySelectorAll('[data-hulkapps-line-price][data-key], [data-hulkapps-ci-price][data-key]').forEach(function (el) {
      var it = byKey[el.getAttribute('data-key')]; if (!it) return;
      var fee = feeOf(props(it)), host = el.parentElement;
      // write Hulk's own figures straight away (the theme re-draws the drawer with Shopify prices before Hulk re-applies them)
      var isUnit = el.hasAttribute('data-hulkapps-ci-price');
      var po = parseFloat(isUnit ? it.original_price : it.original_line_price), pd = parseFloat(isUnit ? it.discounted_price : it.discounted_line_price);
      if (!isNaN(po) && !isNaN(pd) && !(isUnit && fee)) {
        var want = po - pd > 0.004 ? money(po) + money(pd) : money(pd);
        if (el.textContent.replace(/\s+/g, '') !== want)
          el.innerHTML = po - pd > 0.004 ? '<span class="original_price" style="text-decoration:line-through;opacity:.7">' + money(po) + '</span><br><span class="discounted_price">' + money(pd) + '</span>' : money(pd);
      }
      var note = host.querySelector(':scope > .galaxy-note[data-for="' + el.hasAttribute('data-hulkapps-ci-price') + '"]');
      if (!fee) { if (note) note.remove(); el.classList.remove('galaxy-hide'); var u0 = host.querySelector(':scope > .galaxy-unit'); if (u0) u0.remove(); return; }
      if (el.hasAttribute('data-hulkapps-ci-price')) {
        var uo = parseFloat(it.original_price) - fee, ud = parseFloat(it.discounted_price) - fee;
        el.classList.add('galaxy-hide');
        var u = host.querySelector(':scope > .galaxy-unit');
        if (!u) { u = document.createElement('span'); host.insertBefore(u, el.nextSibling); }
        u.className = (el.className.replace(/\bgalaxy-hide\b/g, '') + ' galaxy-unit').trim();
        setHTML(u, (uo - ud > 0.004 ? '<s>' + money(uo) + '</s>' : '') + money(ud));
        if (!note) { note = document.createElement('span'); note.className = 'galaxy-note'; note.setAttribute('data-for', 'true'); host.appendChild(note); }
        setText(note, '+ ' + money(fee) + ' one-off setup');
      } else if (el.closest('.previewCartItem')) {
        if (note) note.remove(); // side cart: the qty line already shows the setup fee
      } else {
        if (!note) { note = document.createElement('span'); note.className = 'galaxy-note'; note.setAttribute('data-for', 'false'); host.appendChild(note); }
        setText(note, 'incl. ' + money(fee) + ' one-off setup');
      }
    });
  }
  function renderDrawer(d) {
    var byKey = {};
    d.cart.items.forEach(function (it) { byKey[it.key] = it; });
    document.querySelectorAll('.previewCartItem').forEach(function (li) {
      var lp = li.querySelector('[data-hulkapps-line-price][data-key]'); if (!lp) return;
      var it = byKey[lp.getAttribute('data-key')]; if (!it) return;
      var fee = feeOf(props(it)), q = parseInt(it.quantity, 10) || 0, unit = parseFloat(it.discounted_price) - fee;
      var txt = q + ' \u00d7 ' + money(unit) + ' each' + (fee ? ' \u00b7 + ' + money(fee) + ' one-off setup' : '');
      var line = li.querySelector('.galaxy-qtyline');
      if (!line) {
        line = document.createElement('span'); line.className = 'galaxy-qtyline';
        var anchor = li.querySelector('.previewCartItem-name') || li.querySelector('[data-hulkapps-line-properties]');
        if (anchor && anchor.classList.contains('previewCartItem-name')) anchor.parentNode.insertBefore(line, anchor.nextSibling);
        else if (anchor) anchor.parentNode.insertBefore(line, anchor);
        else lp.parentNode.insertBefore(line, lp);
      }
      setText(line, txt);
    });
  }
  /* ---------- option lines: short labels, clean values (display only; orders keep Hulk's text) ---------- */
  var LABELS = [[/logo setup/i, 'Setup'], [/position/i, 'Position'], [/instruction/i, 'Notes'], [/upload logo/i, 'Logo file'],
    [/names? for/i, 'Names'], [/numbers? for/i, 'Numbers']];
  function cap(t) { return t.charAt(0).toUpperCase() + t.slice(1); }
  function place(t) { return cap(t.replace(/\bhand\s+/i, '').toLowerCase().trim()); }
  function tidyValue(v) {
    var t = String(v).trim(), fee = '', m;
    t = t.replace(/\s*\[\s*\$\s*([\d,]+(?:\.\d+)?)\s*\]/g, function (x, a) { fee = ' (+$' + a + ')'; return ''; }).trim();
    t = t.replace(/^new logo setup$/i, 'New logo').replace(/^repeat order$/i, 'Repeat order');
    if ((m = t.match(/^(.*?)\s+max\s*\((\d+)\s*mm wide x (\d+)\s*mm high\)$/i))) t = place(m[1]) + ' (max ' + m[2] + ' \u00d7 ' + m[3] + ' mm)';
    else if ((m = t.match(/^(LH|RH)\s+(chest|sleeve)\s*-\s*max\s*(\d+)\s*mm\s*x\s*(\d+)\s*mm/i)))
      t = (m[1].toUpperCase() === 'LH' ? 'Left ' : 'Right ') + m[2].toLowerCase() + ' (max ' + m[3] + ' \u00d7 ' + m[4] + ' mm)';
    else if ((m = t.match(/^(front|back)\s*-\s*(.+?)\s*print only\.?$/i)))
      t = cap(m[1].toLowerCase()) + ' \u2013 ' + m[2].replace(/(\d+)\s*mm\s*x\s*(\d+)\s*mm/i, '$1 \u00d7 $2 mm');
    else if ((m = t.match(/^(.+?):\s*(\d+)\s*mm wide x (\d+)\s*mm high$/i))) t = cap(m[1].toLowerCase()) + ' (' + m[2] + ' \u00d7 ' + m[3] + ' mm)';
    return t + fee;
  }
  function tidyProps() {
    document.querySelectorAll('[data-hulkapps-line-properties]').forEach(function (dl) {
      dl.classList.add('galaxy-props');
      dl.querySelectorAll('.product-option').forEach(function (row) {
        var dt = row.querySelector('dt'), dd = row.querySelector('dd'); if (!dt || !dd) return;
        if (dt.__gOut !== dt.textContent) dt.__gOrig = dt.textContent;
        if (dd.__gOut !== dd.textContent) dd.__gOrig = dd.textContent;
        var rawLabel = dt.__gOrig.replace(/[\s:]+$/g, '').trim(), rawVal = dd.__gOrig.trim();
        if (!rawVal || rawVal === 'undefined') { row.classList.add('galaxy-hide'); return; }
        row.classList.remove('galaxy-hide');
        var label = rawLabel;
        for (var i = 0; i < LABELS.length; i++) if (LABELS[i][0].test(rawLabel)) { label = LABELS[i][1]; break; }
        var outLabel = label + ':';
        if (dt.textContent !== outLabel) dt.textContent = outLabel;
        dt.__gOut = dt.textContent;
        if (/^https?:\/\//.test(rawVal)) {
          if (!dd.querySelector('a.galaxy-file')) dd.innerHTML = '<a class="galaxy-file" href="' + rawVal.replace(/"/g, '&quot;') + '" target="_blank" rel="noopener">View file</a>';
        } else {
          var outVal = tidyValue(rawVal);
          if (dd.textContent !== outVal) dd.textContent = outVal;
        }
        dd.__gOut = dd.textContent;
      });
    });
  }
  var rendering = false;
  function render() {
    var d = data(); if (!d || rendering) return;
    rendering = true;
    try { renderSummary(d); } catch (e) { if (window.console) console.warn('galaxy-cart-fixes summary', e); }
    try { renderLines(d); } catch (e) { if (window.console) console.warn('galaxy-cart-fixes lines', e); }
    try { renderDrawer(d); } catch (e) { if (window.console) console.warn('galaxy-cart-fixes drawer', e); }
    try { tidyProps(); } catch (e) { if (window.console) console.warn('galaxy-cart-fixes props', e); }
    rendering = false;
  }
  // Hulk rewrites these elements after each calculation; re-apply once it settles.
  new MutationObserver(function () { if (ready && !rendering) { clearTimeout(render.t); render.t = setTimeout(render, 150); } })
    .observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- checkout guard + Avada/Hulk ordering ---------- */
  // Avada Order Limits (document.body.onclick) and Hulk (jQuery on document) both react to the same checkout click.
  // Avada ends with form.submit() = plain Shopify checkout (no setup fee / Hulk price); Hulk ends with its draft-order
  // checkout. Whichever finishes first wins. For carts Hulk prices (is_draft_order) we run them in order instead:
  // Avada checks the minimums; if it passes, its form submit is handed to Hulk. Normal carts are left untouched.
  var bypass = false;
  function dbg(o) { if (window.GALAXY_CART_DEBUG) { window.GALAXY_CART_DEBUG.push(o); return true; } return false; }
  function setLabel(btn, txt) {
    if (btn.__galaxyLabel === undefined) btn.__galaxyLabel = btn.tagName === 'INPUT' ? btn.value : btn.innerHTML;
    if (btn.tagName === 'INPUT') btn.value = txt; else btn.textContent = txt;
  }
  function resetLabel(btn) {
    if (btn.__galaxyLabel === undefined) return;
    if (btn.tagName === 'INPUT') btn.value = btn.__galaxyLabel; else btn.innerHTML = btn.__galaxyLabel;
    btn.__galaxyLabel = undefined;
  }
  function hulkFlow() {
    return window.is_draft_order === true && typeof window.hulkappsCheckout === 'function' && !!window.jQuery;
  }
  function toHulk(btn) {
    if (dbg({ step: 'hulk-checkout' })) return;
    var avada = document.body.onclick;
    document.body.onclick = null; // jQuery.trigger would otherwise call Avada's inline handler again
    try { window.jQuery(btn).trigger('click'); } finally { setTimeout(function () { document.body.onclick = avada; }, 0); }
  }
  function orderedCheckout(btn) {
    if (btn.__galaxyBusy) return;
    btn.__galaxyBusy = true;
    setLabel(btn, 'Preparing checkout\u2026');
    var form = btn.closest('form'), avada = document.body.onclick, finished = false, t0 = Date.now();
    function finish(how) {
      if (finished) return; finished = true;
      if (form && form.hasOwnProperty('submit')) delete form.submit;
      btn.__galaxyBusy = false; resetLabel(btn);
      dbg({ avada: how, ms: Date.now() - t0 });
      if (how !== 'blocked') toHulk(btn);
    }
    if (typeof avada !== 'function' || !form) return finish('skipped');
    form.submit = function () { // Avada calls this when the minimums pass (or its check errors)
      [].slice.call(form.querySelectorAll('input[type=hidden][name=checkout]')).forEach(function (i) { i.remove(); });
      finish('passed');
    };
    try { avada.call(document.body, { target: btn, preventDefault: function () {} }); } catch (err) { return finish('error'); }
    (function watch() {
      if (finished) return;
      if (btn.disabled) return finish('blocked'); // Avada disables the button and shows its message
      if (Date.now() - t0 > MAX_WAIT) return finish('timeout');
      setTimeout(watch, 150);
    })();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (!btn || bypass || !window.hulkapps) return;
    evaluate();
    if (isReady()) {
      if (!hulkFlow()) {
        if (dbg({ proceed: 'immediate-ready-normal' })) { e.preventDefault(); e.stopImmediatePropagation(); }
        return;
      }
      e.preventDefault(); e.stopImmediatePropagation();
      orderedCheckout(btn);
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    dbg({ held: true, at: Date.now() });
    if (btn.__galaxyWaiting) return;
    btn.__galaxyWaiting = true;
    setLabel(btn, 'Preparing checkout\u2026');
    var t0 = Date.now();
    (function wait() {
      evaluate();
      var ok = isReady();
      if (!ok && Date.now() - t0 < MAX_WAIT) return setTimeout(wait, 150);
      btn.__galaxyWaiting = false; resetLabel(btn);
      dbg({ proceed: ok ? 'ready' : 'timeout', waited: Date.now() - t0, hasFee: hasFee });
      if (ok && hulkFlow()) return orderedCheckout(btn);
      if (window.GALAXY_CART_DEBUG) return;
      if (!ok && hasFee && typeof window.hulkappsCheckout === 'function') { window.hulkappsCheckout(null); return; }
      bypass = true;
      btn.click();
      setTimeout(function () { bypass = false; }, 1500);
    })();
  }, true);

  /* ---------- minimum per logo line + no Edit pencil on logo lines ---------- */
  // Names/numbers (no setup fee, "minimum 5 per order") stay on Avada's per-order count.
  var MIN_BY_PRODUCT = { '7326491312215': 5, '7326521983063': 10 }; // Logo Embroidery, Logo/Design Printing
  var MIN_BY_VARIANT = { '41371157200983': 5, '41371433271383': 10, '41371433304151': 10, '41371433336919': 10, '41371433369687': 10, '41371433402455': 10 };
  var MIN_NAME = { '7326491312215': 'logo embroidery', '7326521983063': 'logo printing' };
  var bypassMin = false;
  var css2 = document.createElement('style');
  css2.textContent = '.galaxy-min-msg{display:block;margin:8px 0;padding:8px 10px;border:1px solid #c0392b;background:#fdecea;color:#8a1f11;font-size:13px;line-height:1.4;border-radius:3px}' +
    '.galaxy-min-line{outline:2px solid #c0392b;outline-offset:2px}';
  document.head.appendChild(css2);
  function lineMin(it) { return MIN_BY_PRODUCT[String(it.product_id)] || 0; }
  function underMin() { return (cartItems || []).filter(function (it) { var m = lineMin(it); return m && it.quantity < m; }); }
  function where(it) {
    var p = it.properties || {}, pos = '';
    Object.keys(p).forEach(function (k) { if (/position/i.test(k) && p[k]) pos = tidyValue(String(p[k]).replace(/\s*\[[^\]]*\]/g, '')); });
    return pos;
  }
  function showMsg(anchor, html, id) {
    if (!anchor || !anchor.parentNode) return;
    var m = document.getElementById(id);
    if (!m) { m = document.createElement('div'); m.id = id; m.className = 'galaxy-min-msg'; m.setAttribute('role', 'alert'); }
    m.innerHTML = html;
    if (m.nextSibling !== anchor) anchor.parentNode.insertBefore(m, anchor);
  }
  function rowForKey(key, scope) {
    var b = (scope || document).querySelector('.edit_cart_option[data-key="' + key + '"]');
    return b && b.closest('[data-item-row]');
  }
  function markLines() {
    var bad = {};
    underMin().forEach(function (it) { bad[it.key] = it; });
    document.querySelectorAll('[data-item-row]').forEach(function (row) {
      var b = row.querySelector('.edit_cart_option[data-product_id]');
      if (!b) return;
      var pid = String(b.getAttribute('data-product_id')), key = b.getAttribute('data-key');
      if (MIN_BY_PRODUCT[pid]) row.querySelectorAll('[data-open-edit-cart]').forEach(function (a) { a.classList.add('galaxy-hide'); });
      var note = row.querySelector('.galaxy-min-note'), it = bad[key];
      if (it) {
        if (!note) { note = document.createElement('div'); note.className = 'galaxy-min-msg galaxy-min-note'; (b.parentNode || row).appendChild(note); }
        setText(note, 'Minimum ' + lineMin(it) + ' per logo/position \u2013 this line has ' + it.quantity + '. Please increase the quantity or remove it.');
      } else if (note) note.parentNode.removeChild(note);
    });
  }
  setInterval(function () { try { markLines(); } catch (e) {} }, 500);
  // Theme Edit pencil on a logo line: block (it drops position, logo file, notes and the setup fee)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-open-edit-cart]');
    if (!a) return;
    var row = a.closest('[data-item-row]'), b = row && row.querySelector('.edit_cart_option[data-product_id]');
    if (b && MIN_BY_PRODUCT[String(b.getAttribute('data-product_id'))]) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Product page: quantity for a logo must meet the minimum on its own
  function atcForm(el) { var f = el.closest && el.closest('form'); return f && f.querySelector('[name=id]') ? f : null; }
  function formMin(f) { var v = f.querySelector('[name=id]'); return (v && MIN_BY_VARIANT[String(v.value)]) || 0; }
  function prefill() {
    document.querySelectorAll('form [name=id]').forEach(function (v) {
      var f = v.closest('form'), m = formMin(f), q = f.querySelector('input[name=quantity]');
      if (m && q && !q.__galaxyTouched && (parseInt(q.value, 10) || 0) < m) { q.value = m; q.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  setInterval(function () { try { prefill(); } catch (e) {} }, 500); // Avada resets the box to 1 on option changes
  document.addEventListener('input', function (e) { if (e.target.name === 'quantity') e.target.__galaxyTouched = true; }, true);
  function checkAtc(e, f) {
    var m = formMin(f), q = f.querySelector('input[name=quantity]'), n = q ? (parseInt(q.value, 10) || 0) : 0;
    if (!m || !q || n >= m) { var old = document.getElementById('galaxy-min-atc'); if (old) old.parentNode.removeChild(old); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    q.value = m; q.__galaxyTouched = true; q.dispatchEvent(new Event('change', { bubbles: true }));
    var btn = f.querySelector('[data-btn-addtocart], [type=submit]') || q;
    showMsg(btn, 'Minimum ' + m + ' per logo/position (each logo/position is set up separately). Quantity changed to ' + m + ' \u2013 click Add to Cart again, or <a href="/pages/request-a-quote">request a quote</a> for smaller runs.', 'galaxy-min-atc');
  }
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-btn-addtocart]');
    var f = btn && atcForm(btn);
    if (f) checkAtc(e, f);
  }, true);
  window.addEventListener('submit', function (e) {
    var f = e.target; if (f && /\/cart\/add/.test(f.getAttribute('action') || '') && f.querySelector('[name=id]')) checkAtc(e, f);
  }, true);

  // Checkout: block while any logo line is below its minimum (runs before the guard above)
  function minBlock(btn) {
    var bad = underMin();
    var old = document.querySelectorAll('.galaxy-min-checkout');
    if (!bad.length) { old.forEach(function (o) { o.parentNode.removeChild(o); }); return false; }
    var list = bad.map(function (it) { var w = where(it); return MIN_NAME[String(it.product_id)] + (w ? ' (' + w + ')' : '') + ': ' + it.quantity + ' \u2013 minimum ' + lineMin(it); }).join('<br>');
    var id = 'galaxy-min-co-' + (btn.closest('.previewCart, #halo-cart-sidebar, [data-cart-sidebar]') ? 's' : 'p');
    showMsg(btn, 'Some logo lines are below the minimum quantity:<br>' + list + '<br>Please increase the quantity or remove the line to continue.', id);
    document.getElementById(id).classList.add('galaxy-min-checkout');
    bad.forEach(function (it) { var r = rowForKey(it.key); if (r) { r.classList.add('galaxy-min-line'); setTimeout(function () { r.classList.remove('galaxy-min-line'); }, 3000); } });
    return true;
  }
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (!btn || bypassMin) return;
    if (itemsAt > lastMutationEnd && cartItems) {
      if (minBlock(btn)) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation(); // cart changed since last read: re-read first
    refreshCount().then(function () {
      if (minBlock(btn)) return;
      bypassMin = true;
      try { btn.click(); } finally { setTimeout(function () { bypassMin = false; }, 0); }
    });
  }, true);
})();
